import { render, staticRenderFns } from "./ProjectsInProgress.vue?vue&type=template&id=31fc06de&scoped=true"
import script from "./ProjectsInProgress.vue?vue&type=script&lang=js"
export * from "./ProjectsInProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fc06de",
  null
  
)

export default component.exports